import React from 'react';
import { motion } from 'framer-motion';
import { 
  TrendingUp, 
  ShieldCheck, 
  Globe, 
  ArrowRight, 
  Info
} from 'lucide-react';
import { marketInsightData, chartData } from '@/data/marketData';
import { ExecutiveSummary } from '@/components/ExecutiveSummary';
import { TransportSections } from '@/components/TransportSections';
import { Charts } from '@/components/Charts';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { springPresets, fadeInUp, staggerContainer, staggerItem } from '@/lib/motion';

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <ExecutiveSummary data={marketInsightData.executiveSummary} />
      <TransportSections sections={marketInsightData.transportSections} />
      <Charts chartData={chartData} />
    </div>
  );
}